import BizFooter from './biz-footer.vue';

export default BizFooter;
